import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { VStack } from '@rtkwlf/fenrir-react';

import { EmptyResultsContent } from './empty-results-content';

type EmptyResultsProps = {
  title: string;
  description?: string;
  icon?: IconDefinition;
  linkButton?: React.ReactNode;
  className?: string;
  variant?: 'banner' | 'default';
};

export const EmptyResults: React.FunctionComponent<EmptyResultsProps> = ({
  title,
  description,
  icon,
  linkButton,
  className,
  variant = 'default',
}) => {
  if (variant === 'banner') {
    return (
      <VStack
        width="full"
        padding="xlarge"
        xAlign="center"
        gap="medium"
        backgroundColor="widgetSecondary"
        borderWidth="default"
        borderStyle="solid"
        borderRadius="large"
        borderColor="neutralSecondary"
        className={className}
      >
        <EmptyResultsContent
          icon={icon}
          iconSize="2x"
          title={title}
          description={description}
          linkButton={linkButton}
        />
      </VStack>
    );
  }

  return (
    <VStack
      width="full"
      padding="xxlarge"
      xAlign="center"
      gap="medium"
      className={className}
    >
      <EmptyResultsContent
        icon={icon}
        title={title}
        description={description}
        linkButton={linkButton}
      />
    </VStack>
  );
};
